/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useRef, useState } from 'react';
import withStyles from '../../../hoc/withStyles';
import styles from '../styles/HorizontalCarouselCNC.style';

function HorizontalCarouselCNCView(props) {
  const {
    data,
    childrenComp,
    className,
    lastAddedCouponCode,
    displayCards,
    fromCouponTabAction,
    fromCouponTabState,
    isNewCouponUXWithoutTabEnabled,
  } = props;
  const [isDragging, setIsDragging] = useState(false);
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

  const containerRef = useRef(null);
  const tileRef = useRef(null);

  function isElementVisible(element, container) {
    const containerWidth = container?.clientWidth;
    const containerScrollLeft = container?.scrollLeft;
    const elementOffsetLeft = element?.offsetLeft;
    const elementWidth = element?.offsetWidth;

    return (
      elementOffsetLeft >= containerScrollLeft &&
      elementOffsetLeft + elementWidth <= containerScrollLeft + containerWidth
    );
  }

  useEffect(() => {
    const lastAddedCouponDot = document?.querySelector('[data-lastadded="true"]');
    const container = containerRef?.current;
    if (lastAddedCouponDot && lastAddedCouponDot.click) {
      lastAddedCouponDot.click();
    }
    if (container && lastAddedCouponDot && isNewCouponUXWithoutTabEnabled) {
      const scrollMax = lastAddedCouponDot?.offsetLeft - 20;
      container.scrollTo({
        left: scrollMax,
        behavior: 'smooth',
      });
    }
  }, [lastAddedCouponCode]);

  useEffect(() => {
    if (fromCouponTabState) {
      const elements = tileRef?.current;
      const container = containerRef?.current;
      elements?.children[0]?.classList?.add('navigation-tile-cont-active');
      container.scrollLeft = 0;
      fromCouponTabAction(false);
    }
  }, [data?.size]);

  const addActiveClass = (elements, i, activeClass) => {
    if (displayCards === '2') {
      let targetStep =
        i % 2 === 0
          ? elements.querySelector(`#navi_${i - 2}`)
          : elements.querySelector(`#navi_${i - 1}`);
      if (data?.size % 2 !== 0 && i + 1 === data?.size) {
        targetStep = elements.querySelector(`#navi_${data?.size - 1}`);
      }
      targetStep?.classList?.add(activeClass);
    } else {
      elements?.children[i]?.classList?.add(activeClass);
    }
  };

  useEffect(() => {
    const elements = tileRef?.current;
    const activeClass = 'navigation-tile-cont-active';
    elements?.children[0]?.classList?.add(activeClass);

    function detectVisibleChildElements() {
      const container = containerRef?.current;
      const childElements = container?.children;

      for (let i = 0; i < childElements?.length; i += 1) {
        const childElement = childElements[i];
        if (isElementVisible(childElement, container)) {
          elements?.childNodes?.forEach((element) => {
            if (element.classList) {
              element?.classList?.remove(activeClass);
            }
          });
          addActiveClass(elements, i, activeClass);
        }
      }
    }

    const container = containerRef?.current;

    if (container) {
      container.addEventListener('scroll', detectVisibleChildElements);
      return () => {
        container.removeEventListener('scroll', detectVisibleChildElements);
      };
    }
    return null;
  }, [data?.size]);
  const handleMouseDown = (event) => {
    event?.preventDefault();
    const scrollContainer = containerRef?.current;
    scrollContainer?.classList?.add('move');
    setIsDragging(true);
    setStartPosition({ x: event.clientX, y: event.clientY });
  };

  const handleMouseMove = (event) => {
    event?.preventDefault();
    if (isDragging) {
      const dx = event?.clientX - startPosition?.x;
      const dy = event?.clientY - startPosition?.y;
      const scrollContainer = containerRef?.current;
      scrollContainer.scrollLeft -= dx;
      scrollContainer.scrollTop -= dy;
      setStartPosition({ x: event.clientX, y: event.clientY });
    }
  };

  const handleMouseUp = () => {
    const scrollContainer = containerRef?.current;

    scrollContainer?.classList?.remove('move');

    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const couponData = data;

  return (
    <div className={className}>
      <div
        ref={containerRef}
        className="smooth-scroll-list"
        id="scroll-cont"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onKeyDown={() => {}}
        tabIndex={0}
        role={'button'}
      >
        {couponData?.map((coupon, index) => {
          return (
            <div className="smooth-scroll-list-item" id={`scroll_div_${index}`}>
              {childrenComp(props, coupon)}{' '}
            </div>
          );
        })}
      </div>
      <div ref={tileRef} className="smooth-scroll-list-tile" id="navigation-tile-bar">
        {couponData?.map((coupon, index) => {
          const condition = displayCards === '2' ? index % 2 === 0 : true;
          if (isNewCouponUXWithoutTabEnabled) {
            const couponCardElem = document.querySelector(`#scroll_div_${index}`);
            couponCardElem?.setAttribute('data-lastadded', lastAddedCouponCode === coupon.id);
          }
          if (condition && data?.size > (displayCards === '2' ? 2 : 1)) {
            return (
              <>
                <div
                  key={`${coupon.id}_${index}`}
                  role={'button'}
                  className={`navigation-tile-cont`}
                  id={`navi_${index}`}
                  onClick={() => {
                    const container = containerRef.current;
                    const targetElement = document.querySelector(`#scroll_div_${index}`);
                    if (container && targetElement) {
                      const scrollMax = targetElement?.offsetLeft - 20;
                      container.scrollTo({
                        left: scrollMax,
                        behavior: 'smooth',
                      });
                    }
                  }}
                  data-lastadded={lastAddedCouponCode === coupon.id}
                  tabIndex={0}
                  onKeyUp={() => {}}
                >
                  <div className="overlay-scroll" />
                </div>
              </>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}

export default withStyles(HorizontalCarouselCNCView, styles);
